const state = {
	info: {},
	is_forbid_order:true, // 是否禁止全员下单 false 不禁用。true 禁用 非紫涵一直都是不禁用
	is_open_retailer_order:false, // 是否开启零售商多店订货 false 不开启。true 开启
	is_open_global_watermark: false,// 是否开启水印
	watermarkOptions: {
		content: '',
	},

};
const mutations = {
	updateMeetingDetailDate (state, status) {
		state.info = status || {};
	},
	updatIsForbidOrder (state, payload) {
		state.is_forbid_order = payload;
	},
	updateIsOpenRetailerOrder (state, payload) {
		state.is_open_retailer_order = payload;
	},
	updatIsOpenWatermark (state, payload) {
		state.is_open_global_watermark = payload;
	},
	updateWatermarkOptions (state, payload) {
		state.watermarkOptions = payload;
	},

};
export default {
	state,
	mutations
}



// WEBPACK FOOTER //
// ./src/storage/vuex/module/meetingDetail.js